import { HeaderTwo } from "@components/atoms/base-text/header";
import { OutlinedButton } from "@components/atoms/base-button";
import { translate } from "@locales";
import { Link } from "@shopify/hydrogen";

export function CartEmpty({ onClose }) {
  return (
    <div className="w-full flex flex-col gap-y-3 items-center h-full">
      <HeaderTwo className="text-[#D6D6D6] tracking-widest">
        {translate("shop.cart.empty-cart")}
      </HeaderTwo>
      <Link to="/shop">
        <OutlinedButton
          className="flex items-center justify-center"
          onClick={onClose}
        >
          <p className="m-4">{translate("shop.cart.visit-our-shop")}</p>
        </OutlinedButton>
      </Link>
    </div>
  );
}
